import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { FeeProcessComponent } from '../fee-process/fee-process.component';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { retry } from 'rxjs/operators';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
@Component({
  selector: 'app-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss']
})
export class FeesComponent implements OnInit {
  FeeForm: FormGroup;
  FeeTempletList: any;
  FeeModeList: any;
  FeeTempList: any;
  payBtnShow;
  PayBtn = true;
  PayStatus = false;
  StudentIdd: string;
  FeePaid: string;
  StuData: any;
  constId = 0;
  StudentType: '';
  StudentStatus: '';
  Constitution: '';
  Caste: '';
  ShowMsg = false;
  ApprovalCheck = false
  Message2: string;
  FeeTable: any = [];
  feeApplyArray: FormArray;
  dialogRef: MatDialogRef<any>;
  xyz = sessionStorage.getItem("StuCoId");
  pqr = sessionStorage.getItem("StuCgId");
  ADMRecords: any[];
  Dates: any[];
  Message: string;
  TempMsg = false;
  updateBtn = false;
  Message3 = '';
  Message4: string;
  submitpayload: any;
  StuPersonal: any;
  isPopupShown: boolean;
  TotalAmount: number;
  compFeeTemp: any;
  showErrMsg: boolean = false;
  submitted = false;
  showUploadColumn = false;
  showActionColumn = true;
  oldReceiptData: any[];
  newReceiptData: any[];
  feeReceiptFilePath: any;
  showAlreadyPaidColumn = true;
  savebtn: boolean;
  snNo: number | null = null;

  constructor(private fb: FormBuilder,
    public umsService: UmsService,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }
  FcCode = sessionStorage.getItem("faculty");
  CoCode = sessionStorage.getItem("StuCoId");
  CgCode = sessionStorage.getItem("StuCgId");
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  sessionNo = sessionStorage.getItem('session');
  collegeName
  courseName
  ngOnInit(): void {
    this.PayBtn = true;
    this.ShowMsg = false;
    this.Message = '';
    this.ApprovalCheck = false;
    this.Message2 = '';
    this.TempMsg = false;
    this.Message3 = '';
    this.PayStatus = false;
    sessionStorage.getItem("faculty");
    sessionStorage.getItem("course");
    sessionStorage.getItem("college");
    this.admissionSummary();
    this.FeeForm = this.fb.group({

      feeApplyArray: new FormArray([]),
      // Receipt: new FormControl(null)
    })
    this.getPersonalDetails()
    this.ValidatePayment();
    this.fetchDocument();
    // this.ValidateFees();

  }

   admissionSummary() {
  let payload = {};
  payload['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));

  this.umsService.studentCompSummary(payload).subscribe((res) => {
    if (res.status && res.data && res.data.length > 0) {
      this.snNo = res.data[0].SnNo;
      console.log('SessionId / SnNo:', this.snNo);
    }
  });
}

  getPersonalDetails() {
    let payload = {}
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.StuPersonal = res.data[0];
      }
      else {

      }
    })
  }

  getAdmittedData() {
    console.log('this.StuPersonal', this.StuPersonal);

    let payload = {}
    payload['FirstName'] = this.StuPersonal.StuFirstNameEng;
    payload['MotherName'] = this.StuPersonal.StuMothNameEng;
    payload['FatherName'] = this.StuPersonal.StuMidNameEng;
    payload['Gender'] = this.StuPersonal.StuGender;
    payload['DOB'] = this.StuPersonal.StuBirthDate;
    payload['MobNumber'] = this.StuPersonal.StuNumber;
    payload['CgCode'] = '';
    payload['CgName'] = this.collegeName;
    console.log('payload', payload);

    this.umsService.getAdmittedData(payload).subscribe((res) => {
      if (res.status) {
        console.log('i have data', res.data);
        this.getFee()
      }
      else {
        console.log('i dont have matching data');

      }
    })
  }

  getFee() {
    console.log('this.FeeTable', this.FeeTable);
    if (this.FeeTable.length > 0) {
      const payload = {};
      payload['TemplateCode'] = this.FeeTable[0].TemplateCode
      payload['FeeType'] = ''
      this.umsService.getFeeTemplet(payload).subscribe((res) => {
        if (res.status) {
          this.TotalAmount = 0
          res.data.forEach(element => {
            this.TotalAmount += element.FeeAmt
          });
          var bar = new Promise<void>((resolve, reject) => {
            res.data.forEach((element, index, array) => {
              let arr1 = [];
              arr1.push(
                this.fb.group({
                  FeeTemplateCode: new FormControl(this.FeeTable[0].TemplateCode), //add neww
                  StuId: new FormControl(this.StudentPersonalId),
                  FeeType: new FormControl('AF'),
                  FeeHead: new FormControl(element.FeeHead),
                  FeeAmt: new FormControl(element.FeeAmt),
                  FeePaid: new FormControl(element.FeePaid),
                  FeeDue: new FormControl(element.FeeDue),
                  FeeDueDummy: new FormControl(element.FeeDue),
                  FeePaymentMethod: new FormControl('OFFLINE'),
                  TotalPaidAmount: new FormControl(this.TotalAmount),
                  PayMode: new FormControl('OFFLINE'),
                  SnNo: new FormControl(this.FeeTable[0].SessionId),
                  CreatedBy: new FormControl(''),
                  TotalFeeAmount: new FormControl(element.FeeAmount)
                })
              )
              // this.saveApplicationDetails
              // return;
              this.umsService.addFeeTemplet(arr1[0].value).subscribe(res => {

              }
              );
            });
            this.onPaymentRequest()
          })
          bar.then(() => {

          });
        }
      })
    }

  }

  async onPaymentRequest() {
    const randomFiveDigitNumber = Math.floor(10000 + Math.random() * 90000);
    let payload = {
      payment_source: 'Pay-0',
      easepayid: randomFiveDigitNumber,
      card_type: '-',
      mode: '-',
      email: '',
      phone: '',
      key: '',
      txnid: '',
      status: 'Success',
      amount: this.TotalAmount,
      StuId: sessionStorage.getItem('StudentPersonalId'),
      FeeTemplateCode: this.FeeTable[0].TemplateCode,
      FeeType: 'AF',
      SnNo: this.FeeTable[0].SessionId,
      firstname: this.StuPersonal.StuFirstNameEng
    };

    try {
      // Show spinner before API call
      this.spinner.show();

      // Await the API response
      const res = await this.umsService.payZeroFee(payload).toPromise();

      // Hide spinner once response is received
      this.spinner.hide();

      // Show popup based on response, but only if no popup is already shown
      if (!this.isPopupShown) {
        this.isPopupShown = true; // Mark that a popup is being shown

        if (res.status) {
          // this.showPopup('Waved Off', 'Information', 'fas fa-check');
        } else {
          this.showPopup(res.message, 'Alert', 'fas fa-close');
        }
      }

      // Reload data after successful API call
      if (res.status) {
        this.ngOnInit();
      }

    } catch (error) {
      // Handle any error from the API call
      this.spinner.hide();

      if (!this.isPopupShown) {
        this.isPopupShown = true;
        this.showPopup('An error occurred while processing the payment.', 'Error', 'fas fa-exclamation-circle');
      }
    }
  }

  private showPopup(message: string, title: string, icon: string) {
    const data = {
      message: message,
      title: title,
      icon: icon
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    // After closing the popup, reset the flag
    this.dialogRef.afterClosed().subscribe(() => {
      this.isPopupShown = false;  // Reset the flag once the popup is closed
    });
  }

  ValidatePayment() {
    this.spinner.show();
    this.submitpayload = {}
    this.submitpayload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    this.umsService.checkUnClearedSinglePayment(this.submitpayload).subscribe((res) => {
      this.spinner.hide();
      console.log("res: ", res);
      this.ValidateFees();
      // this.UpdatePRNno();
    }, (ERROR: HttpErrorResponse) => {
      alert(ERROR.error.message);
      this.spinner.hide();
    }
    )
  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      let activeFlowObject = res.projectPharam['ActiveFlow']
      let arrActiveFlow = JSON.parse(activeFlowObject);
      if (arrActiveFlow[0]['FeesBeforeScrutiny'] == 1) {
        // this.SelectAllActive = true;
        this.getFeeBeforeScrutiny();
      }
      else if (arrActiveFlow[0]['FeesBeforeScrutiny'] == 0) {
        // this.SelectAllActive = false;
        this.ValidateFees();
      }


    })
  }
  ValidateFees() {
    const payload = {}
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    payload['FeeType'] = 'AF';
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      this.getRgId();
      // this.getFeeTempData();
      this.getFeeModeData();
      this.submit();
      // this.getScrutiny();
    })
  }

  getFeeModeData() {
    this.spinner.show();
    const payload = {};
    payload["Session"] = parseInt(this.sessionNo);
    payload['College'] = sessionStorage.getItem("StuCgId"),
      this.umsService.fetchCheckFeeMode(payload).subscribe(res => {
        this.FeeModeList = res.data;
        sessionStorage.setItem('FeeMode', res.data[0]?.FeeMode);
        this.spinner.hide();
        if (res.data[0].FeeMode == 'ONLIN') {
          this.payBtnShow = true;
        } else {
          this.payBtnShow = false;
        }
      });
  }

  getcollege(CgCode) {
    const payload = {};
    payload['CgCode'] = CgCode
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeName = res.data[0].CgName;

    }, (ERROR: HttpErrorResponse) => {
      // this.collegedataList = [];
      this.spinner.hide();
    })
  }

  getCourse(CoCode) {
    const payload = {};
    payload['CoCode'] = CoCode
    this.umsService.fetchCourseType(payload).subscribe(res => {
      this.spinner.hide();
      this.courseName = res.data[0].CoName;
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  submit() {
    let payload = {};
    this.ADMRecords = [];
    this.Dates = [];
    payload['SnNo'] = parseInt(this.sessionNo);
    payload['InCode'] = 'ADFEE'
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    this.umsService.CheckValidDate(payload).subscribe(res => {
      if (res.status) {
        const courseRecords = res.data.filter(record => record.CoCgCoCode === sessionStorage.getItem("StuCoId") && record.CoCgCgCode === sessionStorage.getItem("StuCgId"));
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];

        if (courseRecords.length > 0) {
          this.ADMRecords = courseRecords.filter(record => record.InCode === 'ADFEE');
        }

        let listCanOpen = false;
        if (this.ADMRecords.length == 0) {
          this.showAlert('Schedule Not Open For This Activity');
          listCanOpen = false;
        }
        else if (this.ADMRecords.length > 0) {
          for (let item of this.ADMRecords) {
            if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
              listCanOpen = true;
              break;
            }
          }
        }

        if (!listCanOpen) {
          for (let item of this.ADMRecords) {
            if (todayDateString > item.ToDate.split('T')[0]) {
              this.showAlert('Admission Fee Payment Dates Are Closed For This Course');
              break;
            } else if (todayDateString < item.FromDate.split('T')[0]) {
              this.showAlert('Schedule Is Not Open For This Activity');
              break;
            }
          }
        }
        if (listCanOpen == true) {
          this.ShowMsg = false;
          this.Message = '';
        }
      } else {
        this.showAlert('Schedule Is Not Open For This Activity');
      }
    });

  }

  showAlert2(message: string) {
    // let data = {
    //   message: message,
    //   title: 'Alert',
    //   icon: 'fas fa-close'
    // };
    // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.ApprovalCheck = true
    this.Message2 = message;
  }

  showAlert(message: string) {
    // let data = {
    //   message: message,
    //   title: 'Alert',
    //   icon: 'fas fa-close'
    // };
    // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.ShowMsg = true
    this.Message = message;
  }
  getFeeTempData() {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = this.snNo,
      payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeType'] = 'AF';
    this.umsService.OldReceiptAdm(payload).subscribe(res => {
      this.oldReceiptData = res.data;
      this.FeeTable = [...this.oldReceiptData];
      this.showAlreadyPaidColumn =
        !(this.oldReceiptData && this.oldReceiptData.length > 0);
      if (this.FeeTable.length > 0) {
        this.CgCode = this.FeeTable[0].CgCode;
        this.CoCode = this.FeeTable[0].CoCode;
        this.getcollege(this.CgCode);
        this.getCourse(this.CoCode);
        sessionStorage.setItem('Currency', this.FeeTable[0].Currency);
      }
      this.FeeTable.forEach((element, i) => {
        console.log('element', element)
        let MiddleName = element['StuMiddleName'] != null ? element['StuMiddleName'] : " "
        const creds = this.FeeForm.controls.feeApplyArray as FormArray;
        creds.push(
          this.fb.group({
            StudentName: new FormControl(element['StuFullNameEng']),
            TemplateName: new FormControl(element['TemplateName']),
            StuType: new FormControl(),
            StuStatus: new FormControl(),
            StuSocial: new FormControl(),
            StuAdm: new FormControl(),
            AlreadyPaid: new FormControl('NO'),
            Receipt: new FormControl(null)
          })
        );
        this.getStudentType(element['StudentType'], i)
        this.getStudentStatus(element['StudentStatus'], i);
        this.getSocial(element['SocialReservation'], i);
        this.getAdmission(element['AdmissionMode'], i);
        this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
        this.SearchFeeDetails(element['TemplateCode'], this.StudentIdd, i)
      });
      this.umsService.SearchFeeAdm(payload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          this.TempMsg = false;
          this.Message3 = '';
          // this.Table = true;
          this.getFeeModeData();
          this.newReceiptData = res.data;
          if (this.oldReceiptData) {
            this.FeeTable = [...this.oldReceiptData, ...this.newReceiptData];
            console.log('this.oldReceiptData',this.oldReceiptData)
            console.log('this.newReceiptData',this.newReceiptData)
            console.log('this.FeeTable',this.FeeTable)
          }
          else {
            this.FeeTable = res.data;
          }
          this.CgCode = res.data[0].CgCode
          this.CoCode = res.data[0].CoCode
          this.getcollege(this.CgCode)
          this.getCourse(this.CoCode)
          sessionStorage.setItem('Currency', res.data[0].Currency)
          // this.studentId = res.data.StuId;
          const creds = this.FeeForm.controls.feeApplyArray as FormArray;
          creds.clear();
          this.FeeTable.forEach((element, i) => {
            console.log('element', element)
            let MiddleName = element['StuMiddleName'] != null ? element['StuMiddleName'] : " "
            const creds = this.FeeForm.controls.feeApplyArray as FormArray;
            creds.push(
              this.fb.group({
                StudentName: new FormControl(element['StuFullNameEng']),
                TemplateName: new FormControl(element['TemplateName']),
                StuType: new FormControl(),
                StuStatus: new FormControl(),
                StuSocial: new FormControl(),
                StuAdm: new FormControl(),
                AlreadyPaid: new FormControl('NO'),
                Receipt: new FormControl(null)
              })
            );
            this.getStudentType(element['StudentType'], i)
            this.getStudentStatus(element['StudentStatus'], i);
            this.getSocial(element['SocialReservation'], i);
            // this.getConstitution(element['constitutional'],i);
            this.getAdmission(element['AdmissionMode'], i);
            // this.getCaste(element['Caste'],i);
            this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
            this.SearchFeeDetails(element['TemplateCode'], this.StudentIdd, i)
          });
          this.compareFeeTemp();
        } else {
          this.spinner.hide();
          if (res.message == 'No Data Found') {
            // this.Table = false;
            // this.FeeTable = [];
            this.TempMsg = true;
            this.Message3 = 'Template Not Defined For This Criteria';
            this.ShowMsg = false;
            this.Message = ''
          }

        }
      });
    })
  }

  compareFeeTemp() {
    const payload = {};
    payload['SessionId'] = this.snNo,
      payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeType'] = 'AF';
    this.umsService.CompareFeeAdm(payload).subscribe(res => {
      this.compFeeTemp = res.data;
      const feeTable = this.FeeTable.filter(x => !('PaymentStatus' in x));
      if (this.compFeeTemp) {
        const notMatched = this.compFeeTemp[0].FeeTemplateCode != (feeTable[0].TemplateCode || feeTable[0]?.TemplateCode == undefined)
        if (notMatched) {
          this.Message = "Please correct the student type in Admission Details.";
          this.ShowMsg = notMatched;
        }
        else {
          this.ShowMsg = false;
        }
      }
    })
  }

  SearchFeeDetails(TempCode, StdId, rowIndex) {
    this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.sessionNo
    payload['FeeType'] = 'AF'
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let data = 0
        res.data.forEach(element => {
          data += element.FeeAmt
        });
        console.log('res.data', res.data);
        console.log('');
        const row = this.FeeTable[rowIndex];
        if (res.data[0]?.FeeTemplateCode == 'PAID') {
          row.FeePaid = 'Already Paid';
          row.PayStatus = true;
          row.PayBtn = false;
          this.showAlreadyPaidColumn = false;
          // this.FeePaid = 'Already Paid';
          // this.PayStatus = true;
          // this.PayBtn = false;
        }
        else if (res.data[0]['TotalPaidAmount'] == 0) {
          this.updateBtn = true;
          row.FeePaid = 'Wave Off';
          row.PayStatus = true;
          row.PayBtn = false;
          this.showAlreadyPaidColumn = false;
          // this.PayBtn = false;
          // this.PayStatus = true;
          // this.FeePaid = 'Wave Off'
        }
        else if (data == res.data[0]['TotalPaidAmount']) {
          row.FeePaid = 'Fees Paid';
          row.PayStatus = true;
          row.PayBtn = false;
          this.showAlreadyPaidColumn = false;
          // this.PayBtn = false;
          // this.PayStatus = true;
          // this.FeePaid = 'Fees Paid'
        }
        else if (data != res.data[0]['TotalPaidAmount']) {
          row.PayStatus = false;
          row.PayBtn = true;
          // this.PayBtn = true;
          // this.PayStatus = false;
        }

      } else {
        const row = this.FeeTable[rowIndex];
        row.PayBtn = true;
        row.PayStatus = false;
        row.FeePaid = null;
        this.getAdmittedData()
      }
    });
  }


  getfeeApplyArrayControls() {
    return (this.FeeForm.get('feeApplyArray') as FormArray).controls;
  }


  openFeeProcessPopUp(item) {
    // localStorage.clear();
    const data = {};
    data['message'] = 'If You Have Already Paid Fees, Please Contact With Your College For Further Information\nOR\nDo You Want To Proceed With Payment?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        sessionStorage.setItem('TemplateCode', item.TemplateCode);
        const dialogRef4 = this.dialog.open(FeeProcessComponent,
          {
            disableClose: true,
            width: "900px",
            height: "400px",
            panelClass: 'custom-dialog-container'
          });
        dialogRef4.afterClosed().subscribe((result) => {
          this.ngOnInit();
        });
      } else {
        this.dialogRef.close();

      }
    });

  }


  getStudentType(id, i) {
    const payload = {};
    payload['CdType'] = 'STYPE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuType').setValue(element['CdDesc']);
        });
      }
    });
  }

  getStudentStatus(id, i) {
    const payload = {};
    payload['CdType'] = 'STUST'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuStatus').setValue(element['CdDesc']);
        });
      }
    });
  }

  getSocial(id, i) {
    const payload = {};
    payload['CdType'] = 'SR'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuSocial').setValue(element['CdDesc']);
        });
      }
    });
  }

  getAdmission(id, i) {
    const payload = {};
    payload['CdType'] = 'AMODE'
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.StuData = res.data
        this.feeApplyArray = this.FeeForm.get('feeApplyArray') as FormArray;
        this.StuData.map((element) => {
          this.feeApplyArray.at(i).get('StuAdm').setValue(element['CdDesc']);
        });
      }
    });
  }


  addnewrecord(item) {
    sessionStorage.setItem('TemplateCode', item.TemplateCode);
    let data = {};
    data['SnNo'] = this.sessionNo
    data['TemplateCode'] = item.TemplateCode
    data['Fee'] = 'Registration Payment Receipt'
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: 'auto',
      // height: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  getRgId() {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.examform(res.data[0]['RgId'])
      }
      else {
        this.getFeeTempData();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.getFeeTempData();
    })
  }

  examform(RgId) {
    const payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem("StuCoId")
    this.umsService.fetchLatestEcid(payload)
      .subscribe((res) => {
        if (res.status) {
          if (res.data[0]['EmSrNo'] > 1) {
            this.FeeTable = [];
            this.TempMsg = true;
            this.Message3 = 'Fees Already Paid';
          }
          else if (res.data[0]['EmSrNo'] == 1) {
            this.getFeeTempData();
          }

        } else {
          this.getFeeTempData();
        }

      }, (ERROR: HttpErrorResponse) => {
        this.getFeeTempData();
      });

  }


  getFeeBeforeScrutiny() {
    const payload = {};
    payload['SessionId'] = this.snNo,
    payload['CoCode'] = sessionStorage.getItem("StuCoId");
    payload['CgCode'] = sessionStorage.getItem("StuCgId");
    payload['StuId'] = this.StudentPersonalId;
    payload['FeeType'] = 'AF';
    this.umsService.payBeforeScrutiny(payload).subscribe((res) => {
      if (res.status) {
        this.FeeTable = res.data;
        this.CgCode = res.data[0].CgCode
        this.CoCode = res.data[0].CoCode
        this.getcollege(this.CgCode)
        this.getCourse(this.CoCode)
        this.getFeeModeData();
        sessionStorage.setItem('Currency', res.data[0].Currency)
        // this.studentId = res.data.StuId;
        this.FeeTable.forEach((element, i) => {
          const creds = this.FeeForm.controls.feeApplyArray as FormArray;
          creds.push(
            this.fb.group({
              StudentName: new FormControl(element['StuFullNameEng']),
              TemplateName: new FormControl(element['TemplateName']),
              StuType: new FormControl(),
              StuStatus: new FormControl(),
              StuSocial: new FormControl(),
              StuAdm: new FormControl(),
              AlreadyPaid: new FormControl('NO'),
              Receipt: new FormControl(null)
            })
          );
          this.StudentIdd = sessionStorage.getItem("StudentPersonalId");
          this.SearchFeeDetails(res.data[0]['TemplateCode'], this.StudentIdd, i)
        });
      }
      else {

      }
    }, (ERROR: HttpErrorResponse) => {

    })
  }


  UpdatePRNno() {
    this.spinner.show();
    let payload = {}
    payload['StuId'] = sessionStorage.getItem("StudentPersonalId");
    payload['CoCode'] = this.CoCode;
    this.umsService.updatePRN(payload).subscribe((res) => {
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {

      this.spinner.hide();
    }
    )
  }
  onFileSelect(event: any, i: number) {

    if (event.target.files.length > 0) {

      const file = event.target.files[0];
    const feeArray = this.FeeForm.get('feeApplyArray') as FormArray;

    feeArray.at(i).get('Receipt')?.setValue(file);

    console.log('Stored File:', feeArray.at(i).get('Receipt')?.value);
      //  this.feeApplyArray.at(i).get('Receipt')?.setValue(file);
    feeArray.at(i).get('Receipt')?.updateValueAndValidity();
      // this.FeeForm.get('Receipt')?.setValue(file);

    }

  }
  onAlreadyPaidChange(i: number) {

    const row = this.feeApplyArray.at(i);

    const alreadyPaid = row.get('AlreadyPaid')?.value;

    if (alreadyPaid == 'YES') {

      this.showUploadColumn = true;
      this.showActionColumn = false;

    } else {

      this.showUploadColumn = false;
      this.showActionColumn = true;

      row.get('Receipt')?.setValue(null);

    }

    row.get('Receipt')?.updateValueAndValidity();

  }
  saveFiles(i: number) {
    this.savebtn = false;
    // this.submitted = true;
     const feeArray = this.FeeForm.get('feeApplyArray') as FormArray;
const file = feeArray.at(i).get('Receipt')?.value;
    if (!file) {
      this.submitted = true;
      // this.showAlert('Please upload receipt');
      return;
    }

    this.spinner.show();

    // const file: File = this.FeeForm.get('Receipt')?.value;

    const reader = new FileReader();

    reader.onload = () => {

      const base64 = reader.result as string;

      const extension = file.name.split('.').pop();

      const filePath =
        'student_documents/' +
        parseInt(this.StudentPersonalId) +
        '_AF_' +
        this.sessionNo +
        '_10_fee_receipt_already_paid';

      // =========================
      // 1. UPLOAD FILE
      // =========================

      const uploadPayload = {
        filePath: filePath,
        base64: base64,
        StuId: this.StudentPersonalId
      };

      this.umsService.saveFiles(uploadPayload).subscribe(

        (uploadRes) => {

          if (!uploadRes.status) {
            this.spinner.hide();
            this.showAlert('Upload Failed');
            return;
          }

          // =========================
          // 2. SAVE DOCUMENT DETAILS
          // =========================

          const dbPayload = {
            // StuFileUpload: filePath + '.' + extension,
            StuFileUpload: uploadRes.file,
            LoginId: parseInt(sessionStorage.getItem('StudentRGID') || '0'),
            StuId: this.StudentPersonalId,
            StuRemarkConfirm: '',
            StuRemarkCheck: '',
            StuHardCopy: '',
            CoCode: '',
            CgCode: '',
            SessionId: '',
            StuDocIssue: '',
            StuDocExpiry: '',
            StuDocumentName: 'Fee receipt already paid',
          };

          this.umsService.addDocumentDetails(dbPayload).subscribe(

            (dbRes) => {

              if (!dbRes.status) {
                this.spinner.hide();
                this.showAlert('Document save failed');
                return;
              }

              // =========================
              // 3. ADD FEE TEMPLATE
              // =========================

              const element = this.FeeTable[0];

              const feePayload = {
                FeeTemplateCode: 'PAID',
                StuId: this.StudentPersonalId,
                FeeType: 'AF',
                FeeHead: 'REGFEE',
                FeeAmt: 0,
                FeePaid: 0,
                FeeDue: 0,
                FeeDueDummy: 0,
                FeePaymentMethod: '',
                TotalPaidAmount: 0,
                PayMode: '',
                SnNo: this.sessionNo,
                CreatedBy: '',
                TotalFeeAmount: 0
              };

              this.umsService.addFeeTemplet(feePayload).subscribe(

                (feeRes) => {

                  if (!feeRes.status) {
                    this.spinner.hide();
                    this.showAlert('Fee template save failed');
                    return;
                  }

                  // =========================
                  // 4. ZERO PAYMENT
                  // =========================

                  const randomFiveDigitNumber = Math.floor(10000 + Math.random() * 90000);

                  const paymentPayload = {
                    payment_source: 'Pay-0',
                    easepayid: randomFiveDigitNumber,
                    card_type: '-',
                    mode: '-',
                    email: '',
                    phone: '',
                    key: '',
                    txnid: '',
                    status: 'Success',
                    amount: 0,
                    StuId: this.StudentPersonalId,
                    FeeTemplateCode: 'PAID',
                    FeeType: 'AF',
                    SnNo: this.sessionNo,
                    firstname: ''
                  };

                  this.umsService.payZeroFee(paymentPayload).subscribe(

                    (paymentRes) => {

                      if (!paymentRes.status) {
                        this.spinner.hide();
                        this.showAlert(paymentRes.message);
                        return;
                      }

                      // =========================
                      // 5. SAVE APPLICATION
                      // =========================

                      const applicationPayload = {
                        StuId: this.StudentPersonalId,
                        SessionId: this.sessionNo,
                        CgCode: sessionStorage.getItem("StuCgId"),
                        CoCode: sessionStorage.getItem("StuCoId"),
                        ApplicationName: 'Admission Fees'
                      };

                      this.umsService.saveApplicationDetails(applicationPayload).subscribe(

                        (appRes) => {

                          this.spinner.hide();

                          if (appRes.status) {

                            this.showAlert('Receipt Uploaded Successfully');
                            this.showUploadColumn = false;
                            this.showActionColumn = true;

                            this.ngOnInit();

                          } else {

                            this.showAlert('Application save failed');
                          }

                        },

                        (appError) => {

                          this.spinner.hide();

                          console.error(appError);

                          this.showAlert('Application API Error');
                        }

                      );

                    },

                    (paymentError) => {

                      this.spinner.hide();

                      console.error(paymentError);

                      this.showAlert('Payment API Error');
                    }

                  );

                },

                (feeError) => {

                  this.spinner.hide();

                  console.error(feeError);

                  this.showAlert('Fee Template API Error');
                }

              );

            },

            (dbError) => {

              this.spinner.hide();

              console.error(dbError);

              this.showAlert('Document API Error');
            }

          );

        },

        (uploadError) => {

          this.spinner.hide();

          console.error(uploadError);

          this.showAlert('Upload API Error');
        }

      );

    };

    reader.readAsDataURL(file);
  }
  viewReceipt() {

    this.spinner.show();

    // const filePath =
    //     'student_documents/' +
    //     parseInt(this.StudentPersonalId) +
    //     '_AF_' +
    //     this.sessionNo +
    //     '_10_fee_receipt_already_paid.pdf';
    const payload = {
      filePath: this.feeReceiptFilePath
    };

    this.umsService.fetchDocument(payload).subscribe((res) => {

      if (res.status) {

        this.spinner.hide();

        this.dialog.open(PdfviewerComponent, {
          width: "400px",
          height: "500px",
          data: res.doc
        });

      } else {

        const payload = {
          StuId: this.StudentPersonalId,
          fileNames: this.feeReceiptFilePath
        };

        this.umsService.getFilesDetails(payload).subscribe((res) => {

          this.spinner.hide();

          this.dialog.open(PdfviewerComponent, {
            width: "400px",
            height: "500px",
            data: res.files[0].base64Data
          });

        });

      }

    });

  }

  fetchDocument() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    // payload['StuDocId'] = '10';
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      if (res.status) {
        const feeReceiptDoc = res.data.find(
          (doc: any) => doc.StuDocumentName === 'Fee receipt already paid'
        );

        this.feeReceiptFilePath = feeReceiptDoc?.StuFileUpload || '';

        console.log('Fee Receipt File Path:', this.feeReceiptFilePath);
      }
      else {
        // this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
    });
  }
  showReceiptColumn(): boolean {
    return this.FeeTable?.some(x => x.PayStatus);
  }
  // saveFiles() {
  //   this.submitted = true;

  //   if (!this.FeeForm.get('Receipt')?.value) {
  //     this.showAlert('Please upload receipt');
  //     return;
  //   }

  //   const file: File = this.FeeForm.get('Receipt')?.value;
  //   const reader = new FileReader();

  //   reader.onload = () => {

  //     const base64 = reader.result as string;
  //     const extension = file.name.split('.').pop();

  //     const filePath =
  //       'student_documents/' + parseInt(this.StudentPersonalId) +
  //       '_AF_' +
  //       this.sessionNo +
  //       '_10_fee_receipt_already_paid.' +
  //       extension;

  //     //  Upload file to S3
  //     const uploadPayload = {
  //       filePath: filePath,
  //       base64: base64,
  //       StuId: this.StudentPersonalId
  //     };

  //     this.umsService.saveFiles(uploadPayload).subscribe(
  //       (res) => {

  //         if (res.status) {
  //           //  Save DB record AFTER upload success
  //           const dbPayload = {
  //             StuFileUpload: filePath,
  //             LoginId: parseInt(sessionStorage.getItem('StudentRGID') || '0'),
  //             StuId: this.StudentPersonalId,
  //             StuRemarkConfirm: '',
  //             StuRemarkCheck: '',
  //             StuHardCopy: '',
  //             CoCode: '',
  //             CgCode: '',
  //             SessionId: '',
  //             StuDocIssue: '',
  //             StuDocExpiry: '',
  //           };

  //           this.umsService.addDocumentDetails(dbPayload).subscribe(
  //             (dbRes) => {

  //               if (dbRes.status) {
  //                 this.showAlert('Receipt Uploaded Successfully');
  //               } else {
  //                 this.showAlert('File uploaded but DB save failed');
  //               }

  //             },
  //             (err) => {
  //               console.error(err);
  //               this.showAlert('File uploaded but DB error occurred');
  //             }
  //           );

  //         } else {
  //           this.showAlert('Upload Failed');
  //         }

  //       },
  //       (error) => {
  //         console.error(error);
  //         this.showAlert('Error uploading file');
  //       }
  //     );
  //   };

  //   reader.readAsDataURL(file);
  // }
}
